/**
 * Coach repository (client) – read-only approved coaches for Online Coaching.
 */
import { collection, getDocs, query, where, orderBy, limit, doc, getDoc } from 'firebase/firestore';
import { db } from '../firebase/config';

const COLLECTION = 'coaches';

function toCoach(d) {
  const data = d.data();
  return {
    id: d.id,
    userId: d.id,
    name: data.name || '',
    phone: data.phone || '',
    bio: data.bio || '',
    yearsExperience: data.yearsExperience ?? 0,
    specialization: data.specialization || '',
    introVideoUrl: data.introVideoUrl || '',
    profileImage: data.profileImage || '',
    approvalStatus: data.approvalStatus || 'pending',
    isActiveCoach: Boolean(data.isActiveCoach),
    createdAt: data.createdAt?.toDate?.() ?? data.createdAt ?? null,
  };
}

export function coachRepository({ getFirestore = () => db } = {}) {
  const firestore = getFirestore();
  const coll = () => collection(firestore, COLLECTION);

  return {
    async listApproved(limitCount = 50, specialization = null) {
      let q = query(
        coll(),
        where('approvalStatus', '==', 'approved'),
        where('isActiveCoach', '==', true),
        orderBy('createdAt', 'desc'),
        limit(limitCount)
      );
      const snap = await getDocs(q);
      let list = snap.docs.map((d) => toCoach(d));
      if (specialization && specialization.trim()) {
        list = list.filter((c) => c.specialization === specialization.trim());
      }
      return list;
    },

    async getById(coachId) {
      const ref = doc(firestore, COLLECTION, coachId);
      const snap = await getDoc(ref);
      if (!snap.exists()) return null;
      return toCoach(snap);
    },
  };
}

export const coachRepo = coachRepository();
